import isNil from 'lodash-es/isNil'
import { I18nId } from '@/i18n/config'
import { Nullable } from '@/types/nullable'

export interface Level {
  type: LevelType
  scoreColor: string
  backgroundColor: string
  levelI18nId: I18nId
  metricLevelI18nId: I18nId
  descriptionI18nId: I18nId
}

export enum LevelType {
  Excellent = 'excellent',
  Good = 'good',
  Normal = 'normal',
  Bad = 'bad',
}

export const levelMap: Record<LevelType, Level> = {
  [LevelType.Excellent]: {
    type: LevelType.Excellent,
    scoreColor: '#26AE60',
    backgroundColor: 'rgba(38, 174, 96, 0.06)',
    levelI18nId: 'kol:score_excellent_text',
    metricLevelI18nId: 'kol:platform_performance_pr_excellent',
    descriptionI18nId: 'kol:score_excellent_description',
  },
  [LevelType.Good]: {
    type: LevelType.Good,
    scoreColor: '#67C23A',
    backgroundColor: 'rgba(103, 194, 58, 0.06)',
    levelI18nId: 'kol:score_good_text',
    metricLevelI18nId: 'kol:platform_performance_pr_good',
    descriptionI18nId: 'kol:score_good_description',
  },
  [LevelType.Normal]: {
    type: LevelType.Normal,
    scoreColor: '#FFD052',
    backgroundColor: 'rgba(255, 208, 82, 0.06)',
    levelI18nId: 'kol:score_normal_text',
    metricLevelI18nId: 'kol:platform_performance_pr_normal',
    descriptionI18nId: 'kol:score_normal_description',
  },
  [LevelType.Bad]: {
    type: LevelType.Bad,
    scoreColor: '#F27A37',
    backgroundColor: 'rgba(242, 122, 55, 0.06)',
    levelI18nId: 'kol:score_bad_text',
    metricLevelI18nId: 'kol:platform_performance_pr_bad',
    descriptionI18nId: 'kol:score_bad_description',
  },
}

const getLevel = (score?: Nullable<number>): Level => {
  if (isNil(score)) {
    return levelMap[LevelType.Bad]
  }

  if (score >= 90) {
    return levelMap[LevelType.Excellent]
  } else if (score >= 80) {
    return levelMap[LevelType.Good]
  } else if (score >= 60) {
    return levelMap[LevelType.Normal]
  }
  return levelMap[LevelType.Bad]
}

export default getLevel
